import { lazyNewMessageErrorHandled } from 'mini-mail-compose-actions-mail';

export const onNewCompose = async () => {
    await lazyNewMessageErrorHandled();
};
